import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThumbtack: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="thumbtack, pin, location, bookmark "><path d="M12 15.25H4.75V12.5L5.12653 12.1235C6.48616 10.7638 7.25 8.91977 7.25 6.99695V2.75H16.75V6.99695C16.75 8.91977 17.5138 10.7638 18.8735 12.1235L19.25 12.5V15.25H12ZM12 15.25V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconThumbtack;
